<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <!-- <link rel="stylesheet" href="primeicons.css"> -->
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="계산" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('CALC')" :disabled="isCloseYn || isCustUser"/>
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="ctrPublicId" v-model="searchParams.ctrPublicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 10rem"
                                @change="changePublicId" :disabled="disabledCtrPublicId" scrollHeight="20em" :editable="true"/>
                        <label for="ctrPublicId">관할행정</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="custCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                     :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="areaTag" v-model="searchParams.areaTag" :options ="cboAreaTags" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" scrollHeight="20em"/>
                        <label for="areaTag">영역분류</label>
                    </div>
                    <div class="p-field-0 p-float-label m-2">
                        <div class="p-inputgroup">
                            <InputText id="calcYm" v-model.trim="searchParams.calcYm" style="width:8rem" type="text" @keydown.enter="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                            <label for="calcYm">평가년도</label>
                            <Button icon="pi pi-search" class="p-button-search" @click="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                        </div>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="calcCnt" type="text" style="width:8rem" v-model="searchParams.calcCnt" disabled/>
                        <label for="calcCnt">평가차수</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" disabled/>
                        <label>시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto mr-2" style="width: 1rem">
                        <label>~</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" disabled/>
                        <label>종료일자</label>
                    </div>
                </div> 
            </template>
        </Toolbar>
        <DataTable id="dt" ref="dt" :value="dataList" showGridlines  
            rowIndexVar="rowIndex" :loading="loading"
            scrollable scrollHeight="78vh"
            class="p-datatable-sm virtualscroll" responsiveLayout="scroll">

            <ColumnGroup type="header">
                <Row>
                    <Column field="rowNo" header="No" :rowspan="2"></Column>
                    <Column field="ctrPublicId" header="관할행정구역" :rowspan="2"  ></Column>
                    <Column field="corpNm" header="업체명" :rowspan="2"></Column>
                    <Column field="routeId" header="운행노선ID" :rowspan="2"></Column>
                    <Column field="routeNm" header="운행노선명" :rowspan="2"></Column>
                    <Column field="routeNm" header="기점관할행정" :rowspan="2"></Column>
                    <Column field="routeNm" header="경유지" :rowspan="2"></Column>
                    <Column field="routeNm" header="종점관할행정" :rowspan="2"></Column>
                    <Column field="areaTag" header="영역" :rowspan="2"></Column>
                    <Column field="getAmt" header="수입금액" :rowspan="2"></Column>
                    <Column header="원가동인" :colspan="2"></Column>
                    <Column header="운행노선원가" :colspan="3"></Column>
                    <Column field="profitAmt" header="운행노선손익" :rowspan="2"></Column>
                    <Column field="yearChgProfitAmt" header="연환산손익" :rowspan="2"></Column>
                </Row>
                <Row>
                    <Column field="runKm" header="운행거리"></Column>
                    <Column field="runCarCnt" header="운행대수"></Column>
                    <Column field="kmCostAmt" header="거리원가"></Column>
                    <Column field="daeCostAmt" header="대당원가"></Column>
                    <Column field="totCostAmt" header="합계"></Column>
                </Row>
            </ColumnGroup>
            
            <Column field="rowNo" header="No" footer-style="border-width: 1px 0px 1px 1px"></Column>
            <Column field="ctrPublicNm" header="관할행정구역" footer-style="border-width: 1px 0px"></Column>
            <Column field="corpNm" header="업체명" footer-style="border-width: 1px 0px"></Column>
            <Column field="routeId" header="운행노선ID" footer-style="border-width: 1px 0px"></Column>
            <Column field="routeNm" header="운행노선명" footer-style="border-width: 1px 0px"></Column>
            <Column field="strPublicNm" header="기점관할행정" footer-style="border-width: 1px 0px"></Column>
            <Column field="viaplace" header="경유지" footer-style="border-width: 1px 0px"></Column>
            <Column field="endPublicNm" header="종점관할행정" footer-style="border-width: 1px 0px"></Column>
            <Column field="areaTagNm" header="영역" footer="합계 : " footer-style="justify-content: flex-end"></Column>
            <Column field="getAmt" header="수입금액" :footer="getgetAmt"  footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="runKm" header="운행거리" :footer="getrunKm" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;" >{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="runCarCnt" header="운행대수" :footer="getrunCarCnt" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="kmCostAmt" header="거리원가" :footer="getkmCostAmt" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="daeCostAmt" header="대당원가" :footer="getdaeCostAmt" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="totCostAmt" header="합계" :footer="gettotCostAmt" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="profitAmt" header="운행노선손익" :footer="getprofitAmt" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>
            <Column field="yearChgProfitAmt" header="연환산손익" :footer="getyearChgProfitAmt" footer-style="justify-content: flex-end; font-size: small;" :sortable="false">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right; font-size: small;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" />
                </template>
            </Column>

        </DataTable>

        <CodeHelpDialog v-model:search="searchCodeHelp" v-model:selection="selectedCodeHelp" v-model:visible="isCodeHelpDialog" @onComplete="codeHelpComplete" />
    </div>
    
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { computed } from 'vue';
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import MA501030Service from '@/service/ma/MA501030Service';
import JsUtils from '@/utilities/JsUtils';
import { useToast } from 'primevue/usetoast';
import CodeHelpDialog from '@/components/CodeHelpDialog';

export default {
    components: {
        'CodeHelpDialog': CodeHelpDialog
    },
    setup() { 
        
        onMounted( async () => {
            searchParams.compSeq = 1;

            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let sDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.sDate = JsUtils.getDateString(sDate);            
            searchParams.eDate = JsUtils.getDateString(new Date());          // 현재 일자

            year.value = new Date().getFullYear();
            calcYms.value = Array.from({ length: year.value - 2010 + 1 }, (_, i) => ({ codeNm: `${year.value - i}`, code: year.value - i }));

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
            codeService.getCodeList({ compSeq:1, upCode:'_area_tag'}).then(data=> cboAreaTags.value = data);  // 영역분류 코드

            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                searchParams.userGbCd = user.userGbCd; // 사용자구분코드

                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                        //alert(JSON.stringify(user.publicId));
                        // 업체 목록을 얻어온다
                        await custService.getCodeList(searchParams).then(data => {
                            custCodes.value = data;
                            // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                            searchParams.corpId = user.custSeq;
                            if(user.userGbCd != null) {
                                // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                                if(user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                    isCustUser.value = true;  
                                    let ctrPublicIdList = [];

                                    publicCodes.value.forEach(element => {
                                        console.log("row.code = " + element.code)
                                        if(user.ctrPublicIds != null && user.ctrPublicIds.includes(element.code)){
                                            ctrPublicIdList.push({code:element.code, codeNm:element.codeNm});
                                        }
                                    });
                                    //alert("ctrPublicIdList.length = "+ ctrPublicIdList.length);
                                    if(ctrPublicIdList.length > 0) {
                                        publicCodes.value = ctrPublicIdList;
                                        disabledCtrPublicId.value = false;
                                    }
                                    else {
                                        //publicCodes.value = {code:user.publicId, codeNm:user.publicNm};
                                        searchParams.ctrPublicId = user.publicId;
                                        disabledCtrPublicId.value = true;
                                    }
                                }
                                // 시군구담당자인 경우
                                if(user.userGbCd == 'ct_mngr') {
                                    searchParams.ctrPublicId = user.publicId;  // 업체소재지
                                }
                            }                                    
                        });
                }
            } 

        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const custService = new CustService();
        const ma501030Service = new MA501030Service();
        const searchParams = reactive({publicId:null,custSeq:null,areaTag:null,sDate: null, eDate: null});
        const dataList = ref([]);
        const dataList2 = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const useOilTagCodes = ref([]);
        const cboAreaTags = ref([]);
        const sDate = ref();
        const eDate = ref();
        const year = ref();
        const calcYms = ref([]);
        const toast = useToast();
        const loading = ref(false);
        const yns = ref([
            {codeNm: '사용', code: 1},
            {codeNm: '중지', code: 2}
        ])
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        // 관할행정 선택여부
        const disabledCtrPublicId = ref(false);

        // 코드도움 Dialog
        const isCodeHelpDialog = ref(false);    // 코드도움다이얼로그 표시 여부
        const searchCodeHelp = reactive({compSeq:1, helpId:"_calc_cnt", conds:[{'calcYm':null}]});  // 코드도움 검색조건
        const selectedCodeHelp = ref({});       // 코드도움 다이얼로그 검색결과에서 선택된 항목

        // 마감여부
        const isCloseYn = ref(false);

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":custCodes
                        searchMA501030();
                    break;
                case "CALC":
                        calculate();
                    break;
                default:
            }
        }

        const btnDialog = (_act, _str) => {
            switch(_act) {
                case 'CodeHelpDialog':
                    // CodeHelpDialog는 공통으로 사용하기 때문에 특정한 Id( ex: calcYm)로 넘기지말고 배열에 담아 넘겨야 한다
                    // 또한, CodeHelpDialog에 넘기는 검색조건도 하나 이상일 수 있다
                    searchCodeHelp.conds[0] = _str;  

                    // CodeHelpDialog를 표시한다
                    isCodeHelpDialog.value = true;

                    // 기존 검색조건을 초기화한다
                    searchParams.calcCnt = null;
                    searchParams.fromDate = null;
                    searchParams.toDate = null;
                    break;
                default:
                    break;
            }
        }

        const codeHelpComplete = () => {
            //alert('codeHelpComplete');
            //alert('selectedCodeHelp.value = ' + JSON.stringify(selectedCodeHelp.value));
            searchParams.calcYm = selectedCodeHelp.value.CALC_YM;
            searchParams.calcCnt = selectedCodeHelp.value.CALC_CNT;
            searchParams.fromDate = selectedCodeHelp.value.CALC_FR_YMD;
            searchParams.toDate = selectedCodeHelp.value.CALC_TO_YMD;
            
            if(selectedCodeHelp.value.CLOSE_YN == 'Y'){
                isCloseYn.value = true; 
            }else if(selectedCodeHelp.value.CLOSE_YN == 'N'){
                isCloseYn.value = false; 
            }
            //selectedCodeHelp.value = {};
        }

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
            var num = Number(value).toFixed(2);
            return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        const calculate = () => {
            if(!JsUtils.checkUndefineColumns(searchParams, ["ctrPublicId","calcYm","calcCnt"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'계산처리시 관할행정과 평가년도와 평가차수는 필수입력 항목입니다', life:3000});
                return;
            }

            loading.value = true;
            searchParams.calcYm = JsUtils.convertYYToString(searchParams.calcYm);  
            //alert('searchParams = ' + JSON.stringify(searchParams));   
            ma501030Service.calculate(searchParams).then(data => {                 
                //searchMA501030();
                loading.value = false;

                if (data.status == '0') {
                    toast.add({
                        severity: 'success',
                        summary: '계산 처리 완료',
                        detail: '계산 처리가 완료되었습니다.',
                        life: 4000
                    });

                    searchMA501030();
                    
                } else {
                    toast.add({
                        severity: 'warn',
                        summary: '계산 처리 오류',
                        detail: data.result
                    });
                }
            });
        };

        const searchMA501030 = () => {
            
            if(!JsUtils.checkUndefineColumns(searchParams, ["calcYm","calcCnt"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'평가년도와 평가차수는 필수입력 항목입니다', life:2000});
                return;
            }

            // 검색조건의 Calendar에서 선택한 날짜(2019-12-31T15:00:00.000) 또는 문자열(2010-01-01)로 'YYYY-MM-DD' 형식으로 변환한다 ex) '2010-01-01'
            searchParams.sDate = JsUtils.convertDateToString(searchParams.sDate);
            searchParams.eDate = JsUtils.convertDateToString(searchParams.eDate);
            //alert('searchParams = '+ JSON.stringify(searchParams));

            loading.value = true;
            ma501030Service.getList(searchParams).then(data => {      
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});            
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const changePublicId= () => {
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            if(isCustUser.value) {
                return;
            }
            if(searchParams.ctrPublicId != null) {
                custService.getCodeList(searchParams).then(data => {
                    custCodes.value = data;
                });
            }
            else {
                custCodes.value = [];
            }
            searchParams.corpId = null;
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            //JsUtils.downloadExcel2('dt');  // id='dt'

            dataList2.value = [];
            dataList.value.forEach(row => {
                dataList2.value.push({'No': row.rowNo, '관할행정구역': row.ctrPublicNm, '업체명':row.corpNm, '운행노선ID':row.routeId, '운행노선명':row.routeNm, 
                '기점관할행정':row.strPublicNm, '경유지':row.viaplace, '종점관할행정':row.endPublicNm, '영역':row.areaTagNm, 
                '수입금액':row.getAmt,  '운행거리':row.runKm, '운행대수':row.runCarCnt, '거리원가':row.kmCostAmt, '대당원가':row.daeCostAmt, '합계':row.totCostAmt, 
                '운행노선손익':row.profitAmt, '연환산손익':row.yearChgProfitAmt});
            }); 

            JsUtils.downloadExcel(dataList2.value);
        }

        // CSV 다운로드
        const exportCSV = () => { 
            //alert(JSON.stringify(dt.value));
            dt.value.exportCSV();   // dt는 ref="dt"
        };


        const getgetAmt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.getAmt;
            }
            return formatToPrice(total);
        });

        const getrunKm = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += parseFloat(dataRow.runKm);
            }
            return formatToPrice(total);
        });

        const getrunCarCnt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.runCarCnt;
            }
            return formatToPrice(total);
        });

        const getkmCostAmt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.kmCostAmt;
            }
            return formatToPrice(total);
        });

        const getdaeCostAmt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.daeCostAmt;
            }
            return formatToPrice(total);
        });

        const gettotCostAmt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.totCostAmt;
            }
            return formatToPrice(total);
        });

        const getprofitAmt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.profitAmt;
            }
            return formatToPrice(total);
        });

        const getyearChgProfitAmt = computed(() => {
            let total = 0;
            for(let dataRow of dataList.value) {
                total += dataRow.yearChgProfitAmt;
            }
            return formatToPrice(total);
        });

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, cboAreaTags, sDate, eDate, loading, isCustUser, isCloseYn, disabledCtrPublicId, dataList2,
            yns, custCodes, btnDialog, codeHelpComplete, formatToPrice, btnAct, downloadExcel, exportCSV, changePublicId, calculate,
            isCodeHelpDialog, searchCodeHelp, selectedCodeHelp, 
            getgetAmt, getrunKm, getrunCarCnt, getkmCostAmt, getdaeCostAmt, gettotCostAmt, getprofitAmt, getyearChgProfitAmt
        }
    }
}
</script>

<style lang="scss" scoped>

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
